import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, from, of, switchMap } from 'rxjs';
import { DealerFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from './privacy.actions';

@Injectable()
export class PrivacyEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly store = inject(Store);
    protected readonly dealerApi = inject(DealerApiService);

    loadDealerPrivacy$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadDealerPrivacy),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerSlug)),
            switchMap(([, dealerSlug]) =>
                from(this.dealerApi.getPrivacyContent(dealerSlug)).pipe(
                    switchMap((privacy) => [actions.loadDealerPrivacySuccess({ privacy })]),
                    catchError((error) => of(actions.loadDealerPrivacyFailure({ error }))),
                ),
            ),
        );
    });
}
